import { FieldWrapper, UnderLineText } from "./styles";
import { Trans, useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { colors } from "../../../styles/colors";
import { Block } from "../../../styles/basicStyles";
import { Field } from "react-final-form";
import { FC, useState } from "react";
import CheckboxGroupInput from "../../../components/inputs/checkboxGroupInput";
import RadioGroupInput from "../../../components/inputs/radioGroupInput";
import TextAreaInput from "../../../components/inputs/textAreaInput";
import CheckboxInput from "../../../components/inputs/checkboxInput";
import TextInput from "../../../components/inputs/textInput";

const FormFields: FC = () => {
  const [showOtherField, setOtherField] = useState<boolean>(false);
  const { t } = useTranslation();
  const router = useRouter();

  const servicesOptions = [
    { value: '1', label: t("WEB_OR_MOBILE_DEVELOPMENT") },
    { value: '2', label: t("PRODUCT_DESIGN") },
    { value: '4', label: t("OPTIMIZATION_OF_PROCESSES") },
    { value: '6', label: t("DESIGN_OR_DEVELOPMENT_OUTSOURCING") },
    { value: '5', label: t("OTHER") },
  ];

  const budgetOptions = [
    { value: '1', label: `${t("LESS_THAN")} 20K €` },
    { value: '2', label: "20-40K €" },
    { value: '3', label: "40-75K €" },
    { value: '4', label: `${t("MORE_THAN")} 75K €` },
  ]; 

  const referralOptions = [
    { value: '1', label: t("RECOMMENDATION") },
    { value: '2', label: t("SEARCH_ENGINE") },
    { value: '3', label: t("SOCIAL_MEDIA") },
    { value: '4', label: t("CLUTCH") },
    { value: '6', label: t("CONFERENCE") },
    { value: '5', label: t("OTHER") },
  ];

  const checkReferral = (values: string[]) => {
    if(values?.includes('5')) {
      if(!showOtherField) setOtherField(true);
    }
    else setOtherField(false);
  };

  return (
    <Block fDirection="column">
      <FieldWrapper>
        <Field name="name">
          {(props) => (
            <TextInput
              {...props}
              label={t("NAME")}
              placeholder={t("ENTER_YOUR_NAME")}
              withAsterisk
            />
          )}
        </Field>
      </FieldWrapper>
      <FieldWrapper>
        <Field name="email">
          {(props) => (
            <TextInput
              {...props}
              label={t("EMAIL")}
              placeholder={t("ENTER_YOUR_EMAIL")}
              withAsterisk
            />
          )}
        </Field>
      </FieldWrapper>
      <FieldWrapper>
        <Field name="contact">
          {(props) => (
            <TextInput
              {...props}
              label={t("CONTACT_NUMBER")}
              placeholder={t("ENTER_YOUR_CONTACT_NUMBER")}
            />
          )}
        </Field>
      </FieldWrapper>
      <FieldWrapper>
        <Field name="interests">
          {(props) => (
            <CheckboxGroupInput
              {...props}
              label={t("WHAT_SERVICE_ARE_YOU_INTERESTED_IN")}
              options={servicesOptions}
              withAsterisk
            />
          )}
        </Field>
      </FieldWrapper>
      <FieldWrapper>
        <Field name="budget">
          {(props) => (
            <RadioGroupInput
              {...props}
              label={t("PROJECT_BUDGET")}
              options={budgetOptions}
              withAsterisk
            />
          )}
        </Field>
      </FieldWrapper>
      <FieldWrapper>
        <Field name="referral">
          {(props) => (
            <CheckboxGroupInput
              {...props}
              label={t("REFERRAL")}
              options={referralOptions}
              withAsterisk
              afterChange={checkReferral}
            />
          )}
        </Field>
      </FieldWrapper>
      {
        showOtherField &&
        <FieldWrapper>
          <Field name="other_referral">
            {(props) => (
              <TextInput
                {...props}
                label={t("OTHER_INTERESTS")}
                placeholder={t("INPUT_OTHER_REFERRAL_PLACEHOLDER")}
                withAsterisk
              />
            )}
          </Field>
        </FieldWrapper>
      }
      <FieldWrapper>
        <Field name="website">
          {(props) => (
            <TextInput
              {...props}
              label={t("IS_YOUR_PRODUCT_LIVE")}
              placeholder={t("ENTER_LINK")}
            />
          )}
        </Field>
      </FieldWrapper>
      <FieldWrapper>
        <Field name="about">
          {(props) => (
            <TextAreaInput
              {...props}
              label={t("TELL_US_ABOUT_YOUR_PROJECT_AND_YOUR_GOALS")}
              placeholder={t("TELL_US_ABOUT_A_BIT_MORE_ABOUT_YOUR_MAIN_GOALS")}
              withAsterisk
            />
          )}
        </Field>
      </FieldWrapper>
      <FieldWrapper>
        <Field name="privacy">
          {(props) => (
            <CheckboxInput
              {...props}
              label={
                <Trans
                  i18nKey="CONFIRM_PRIVACY_POLICY"
                  components={{
                    PrivacyPolicy: (
                      <UnderLineText
                        color='#585858'
                        onClick={() => router.push("/privacy-policy")}
                      />
                    ),
                  }}
                />
              }
              variant="secondary"
            />
          )}
        </Field>
      </FieldWrapper>
    </Block>
  );
};

export default FormFields;
